var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    fill: "white",
    width: 19,
    height: 8,
    viewBox: "0 0 19 8",
    id: "input-password-eye",
    x: 317,
    y: 324,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0s1.776 4.39 8.5 4.5C16.224 4.61 18 0 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5v3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5l.818 2.886M16.5 3l1.664 2.496M5.5 4.5l-.818 2.886M2.5 3L.836 5.496"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgd2lkdGg9IjE5IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAxOSA4IiBpZD0iaW5wdXQtcGFzc3dvcmQtZXllIiB4PSIzMTciIHk9IjMyNCIKICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnICBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTEgMHMxLjc3NiA0LjM5IDguNSA0LjVDMTYuMjI0IDQuNjEgMTggMCAxOCAwIi8+CiAgICA8cGF0aCBkPSJNOS41IDV2MyIgb3BhY2l0eT0iLjciLz4KICAgIDxwYXRoIGQ9Ik0xMy41IDQuNWwuODE4IDIuODg2TTE2LjUgM2wxLjY2NCAyLjQ5Nk01LjUgNC41bC0uODE4IDIuODg2TTIuNSAzTC44MzYgNS40OTYiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgEye as ReactComponent };